import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';

class Table extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { key, tit, data } = this.props.content;
        const classN = () => {
            if (key === 'suspend') {
                return styles.suspend;
            }
            if (key === 'mrgg') {
                return styles.mrgg;
            }
        };

        return (
            <table className={styles.table} border="0">
                <tbody className={classN()}>
                    <tr>
                        {tit &&
                            tit.length > 0 &&
                            tit.map &&
                            tit.map((item, index) => {
                                const idx = item.indexOf('?');

                                return (
                                    <th key={index}>
                                        {idx === -1 ? (
                                            item
                                        ) : (
                                            <React.Fragment>
                                                {item.substring(0, idx)}
                                                <span>{item.substring(idx + 1, item.length)}</span>
                                            </React.Fragment>
                                        )}
                                    </th>
                                );
                            })}
                    </tr>
                    {data &&
                        data.length > 0 &&
                        data.map &&
                        data.map((item, index) => (
                            <tr key={index}>
                                {item.map((_item, _index) => (
                                    <td
                                        key={_index}
                                        className={
                                            (key === 'ipo' && _index === 2) || (key === 'suspend' && _index === 3)
                                                ? styles.bold
                                                : ''
                                        }>
                                        {typeof _item === 'string' &&
                                            (_item.indexOf('?') === -1 ? (
                                                _item
                                            ) : (
                                                <React.Fragment>
                                                    <span className={styles.red}>
                                                        【{_item.substring(0, _item.indexOf('?'))}】
                                                    </span>
                                                    {_item.substring(_item.indexOf('?') + 1, _item.length)}
                                                </React.Fragment>
                                            ))}
                                        {typeof _item !== 'string' && (
                                            <a
                                                href={_item.url}
                                                rel={rel}
                                                target="_blank"
                                                title={key === 'mrgg' && _index === 0 ? _item.name : ''}>
                                                {_item.name.indexOf('?') === -1 ? (
                                                    _item.name
                                                ) : (
                                                    <React.Fragment>
                                                        <span className={styles.red}>
                                                            【{_item.name.substring(0, _item.name.indexOf('?'))}】
                                                        </span>
                                                        {_item.name.substring(
                                                            _item.name.indexOf('?') + 1,
                                                            _item.name.length,
                                                        )}
                                                    </React.Fragment>
                                                )}
                                            </a>
                                        )}
                                    </td>
                                ))}
                            </tr>
                        ))}
                </tbody>
            </table>
        );
    }
}

export default errorBoundary(Table);
